import { render, staticRenderFns } from "./AudienceVoteView.vue?vue&type=template&id=3ad6de48&scoped=true"
import script from "./AudienceVoteView.vue?vue&type=script&lang=ts&setup=true"
export * from "./AudienceVoteView.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./AudienceVoteView.vue?vue&type=style&index=0&id=3ad6de48&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ad6de48",
  null
  
)

export default component.exports